import './media.css'
import Header from "../header/Header";
import video1 from "../../assets/images/video-1.png";
import video2 from "../../assets/images/video-2.png";
import video3 from "../../assets/images/video-3.png";
import blank from "../../assets/images/blank.png";
import pathImage from "../../assets/images/path-image.jpg";
import Footer from "../footer/Footer";
import ImageSection from "../imageSection/ImageSection";
import ScrollToTop from "../scrollToTop/ScrollToTop";
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpotify } from '@fortawesome/free-brands-svg-icons';

const Media = () => {
    return (
        <div>
            <ScrollToTop />
            <Header/>
            <div className='media-blocks'>
                <div className='therapy-professionals-text-container'>
                    <div className='therapy-professionals-title'>
                        Publications & Media
                    </div>
                    <div className='pt-[55px]'>
                        <div className='topic-sections-column'>
                            <div className='topic-sections-row-media'>
                                <div className='relative text-light-blue'>
                                    <img className="image-block" src={video1}
                                         alt=""/>
                                    <div className='section-text'>
                                        <div className='section-title'>
                                            Media - Video
                                        </div>
                                        <div className='section-body'>
                                            YouTube: Dr. Gayle Cordes, DBH | Integrated Care, EDMR, Trauma Informed Care | Doctor of Behavioral Health
                                        </div>
                                        <div className='button'>
                                            <a href={"https://www.youtube.com/watch?v=eJBwkRus6Zw"}>
                                                <button className='learn-more-btn'>
                                                    Watch On Youtube
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className='coaching-section'>
                                    <img className="image-block" src={video2}
                                         alt=""/>
                                    <div className='section-text'>
                                        <div className='section-title'>
                                            Media - Video
                                        </div>
                                        <div className='section-body'>
                                            YouTube: Gayle Cordes LPC, DBH, LISAC | PCS Referring Therapist
                                        </div>
                                        <div className='button'>
                                            <a href={"https://www.youtube.com/watch?v=Vhhe_WWuvio"}>
                                                <button className='learn-more-btn'>
                                                    Watch On Youtube
                                                </button>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='pb-[88px]'>
                        <div className='topic-sections-column'>
                            <div className='topic-sections-row-media'>
                                <div className='consulting-section'>
                                    <img className="image-block" src={video3}
                                         alt=""/>
                                    <div className='section-text'>
                                        <div className='section-title'>
                                            Media - Video & Podcast
                                        </div>
                                        <div className='section-body'>
                                            YouTube: From Compassion Fatigue to Compassion Resilience | Cummings Graduate Institute
                                        </div>
                                        <div className='flex flex-row'>
                                            <div className='button'>
                                                <a href={"https://www.youtube.com/watch?v=wg9OL6hXSoU"}>
                                                    <button className='learn-more-btn'>
                                                        Watch On Youtube
                                                    </button>
                                                </a>
                                            </div>
                                            <a href={"https://open.spotify.com/episode/68hIeucvSQuvFKZIXM4g92?si=4cve3JuSRBaezmF1f87Fww&nd=1&dlsi=c83bd443803a41d6"} className="self-end">
                                                <div className='group p-2 bg-beige rounded-full ml-4 xl:p-4 hover:bg-dark-blue hover:ease-in-out duration-700'>
                                                    <FontAwesomeIcon icon={faSpotify} className='text-dark-blue group-hover:text-beige' />
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className='consulting-section hidden xl:block'>
                                    <img className="image-block" src={blank}
                                         alt=""/>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='therapy-professionals-title'>
                        Integrated Behavioral Health: Applying the Biodyne Model in Healthcare
                    </div>
                    <div className='therapy-professionals-body'>
                        The mission of our team for Chapter 9  “The Trauma Connection:  What Every Integrated Care Provider Needs to Know,” in the newly published text Integrated Behavioral Health: Applying the Biodyne Model in Healthcare is to broadcast the message that trauma is not the exception in patient populations, it is the norm.  Its unaddressed weight drives soaring healthcare costs, worsening outcomes and provider burnout. Trauma-informed providers, working within integrated care models, offer medicine a rare opportunity: not to mop up downstream consequences but to turn off the faucet at its source. For clinicians committed to health optimization, understanding trauma isn’t ancillary to excellent care, it’s the missing cornerstone.
                        <div className='italic font-bold mt-1'>Dr. Gayle Cordes</div>
                        <div className='italic font-bold'>Lead Author</div>
                    </div>
                    <a href="https://www.taylorfrancis.com/reader/read-online/5b6ea41f-91a0-4b85-b0ff-698b8aeb6753/chapter/pdf?context=ubx">
                        <div className='button mb-8'>
                            <button className='learn-more-about-btn'>
                                Read Paper
                            </button>
                        </div>
                    </a>
                    <div className='therapy-professionals-title'>
                        Guidelines for Virtual EMDR Therapy
                    </div>
                    <div className='therapy-professionals-body'>
                        Ground breaking guidelines for the delivery of EMDR therapy developed and published February 2020.
                    </div>
                    <a href="https://www.emdria.org/wp-content/uploads/2020/04/virtual_tg_report_for_member.pdf">
                        <div className='button'>
                            <button className='learn-more-about-btn'>
                                Read Paper
                            </button>
                        </div>
                    </a>
                </div>
                <div className='image-side-panel hidden xl:block'>
                    <img className="path-image" src={pathImage}
                         alt=""/>
                </div>
            </div>
            <ImageSection/>
            <Footer/>
        </div>
    )
}

export default Media;
